<template>
  <div>
    <v-container>
            <v-row justify-space-between>
              <v-col>
                <v-card class="pa-2 mr-2" flat min-height="340px" height="100%">
                  <UserManagment />
                </v-card>
              </v-col>
            </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
    import UserManagment from "@/components/UserManagment";

export default {
  components: {
        UserManagment
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
  data: () => ({
    loading: false,
  })
};
</script>

<style>
</style>